<template>
  <div class="user-info-container">
    <div
      class="subscribe"
      v-if="showSubscribe">
      <!-- <div
        class="subscribe-btn"
        @click="subscribeOrder"></div> -->
      <img
        @click="subscribeOrder"
        src="@/assets/img/subscribe.png"
        alt="" />
    </div>
    <div class="user-info-box">
      <div class="user-avatar-box">
        <div v-if="userInfo.photo">
          <img
            :src="`${imageBaseUrl}/${userInfo.photo}?token=${getTokenId()}`"
            class="avatar" />
        </div>
        <div
          v-else
          class="common-button-box">
          <div class="circle-avatar">
            <i class="el-icon-user-solid" />
          </div>
        </div>
      </div>
      <div class="common-dropdown-box">
        <el-dropdown
          @command="handleCommand"
          trigger="hover"
          @visible-change="getUserCountInfo">
          <div class="user-name-box">
            <div
              v-if="isStarRiver"
              class="text-overflow name">
              {{ userInfo.phoneNumber }}
            </div>
            <div
              v-else
              class="text-overflow name">
              {{ userInfo.surname }}
            </div>
            <i class="el-icon-arrow-down icon"></i>
          </div>
          <el-dropdown-menu
            v-if="$theme.get().value !== 'dark'"
            slot="dropdown"
            class="dropdown-primary common-dropdown-menu common-dropdown-menu-topMenu">
            <div class="dropdown-menu usertip">
              <div class="usertip-expirationTime">
                <img
                  v-if="!countIsExpired"
                  class="usertip-expirationTime-img"
                  :src="userInfoType"
                  alt=""
                  srcset="" />
                <span class="usertip-expirationTime-text">
                  <span v-if="!countIsExpired">
                    {{ endTime }}
                  </span>
                  <span
                    class="expiredDate"
                    v-if="!countIsExpired">
                    账号到期
                  </span>
                  <span
                    v-else
                    class="expiredDate"
                    >账号已过期
                    <span
                      class="expiredDate-text"
                      @click="renewalOrder"
                      >请续费</span
                    >
                  </span>
                </span>
              </div>
              <div class="usertip-buyOrder">
                <div
                  class="usertip-buyOrder-btn"
                  @click="buyOrder">
                  订阅套餐
                  <i class="el-icon-arrow-right usertip-buyOrder-btn-arrow"></i>
                </div>
              </div>
              <div class="usertip-space">
                <div class="usertip-space-userSpace">
                  <span class="usertip-space-userSpace-text">
                    <span class="usertip-space-userSpace-text-label"
                      >我的空间</span
                    >
                    ({{ diskUsedSpace }}/{{ popInfo?.diskVolume || 0 }}GB)
                  </span>
                  <!-- <el-button
                    size="small"
                    type="primary"
                    class="usertip-space-userSpace-addSpace primary-btn"
                    @click="addSpace"
                    >扩容</el-button
                  > -->
                </div>
                <div class="usertip-space-userProgress">
                  <el-progress
                    :class="usedProgress >= 90 ? 'redColor' : 'blueColor'"
                    :text-inside="true"
                    :stroke-width="4"
                    define-back-color="rgba(0,0,0,0.05)"
                    :percentage="usedProgress"></el-progress>
                  <div class="usertip-space-userProgress-text">
                    {{ canUsedSpace }}可用
                  </div>
                </div>
              </div>
              <el-dropdown-item command="1">
                <div class="usertip-dropItem">
                  <span class="usertip-dropItem-icon">
                    <img
                      src="@/assets/img/acountInfo.png"
                      style="width: 20px; height: 20px; margin-right: 8px"
                      alt=""
                      srcset="" />
                    <span>账号信息</span>
                  </span>
                  <span class="usertip-dropItem-arrow">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="3">
                <div class="usertip-dropItem">
                  <span class="usertip-dropItem-icon">
                    <img
                      src="@/assets/img/orderInfo.png"
                      style="width: 20px; height: 20px; margin-right: 8px"
                      alt=""
                      srcset="" />
                    <span>订单信息</span>
                  </span>
                  <span class="usertip-dropItem-arrow">
                    <i class="el-icon-arrow-right"></i>
                  </span>
                </div>
              </el-dropdown-item>
              <el-dropdown-item command="2">
                <div class="loginOut">退出登录</div>
              </el-dropdown-item>
            </div>
          </el-dropdown-menu>
          <el-dropdown-menu
            v-else
            slot="dropdown"
            class="dropdown-primary common-dropdown-menu common-dropdown-menu-darkMenu">
            <el-dropdown-item command="1">
              <icon-svg
                icon-class="ic-chakanxinxi"
                class="icon" />
              <span>查看信息</span>
            </el-dropdown-item>
            <el-dropdown-item command="2">
              <icon-svg
                icon-class="ic-tuichudenglu"
                class="icon" />
              <span>退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- <div class="change-theme-box">
      <el-switch
        class="change-theme-box-switch"
        v-model="themeType"
        active-icon-class="el-icon-sunny"
        inactive-icon-class="el-icon-moon"
        active-color="rgba(37,128,255,0.05)"
        inactive-color="#2580ff"
        active-value="stellar-light"
        inactive-value="dark"
        @change="changeTheme">
      </el-switch>
    </div> -->
    <!-- <div v-if="isLogoVisible" class="split-line"></div> -->
    <div
      v-if="isLogoVisible"
      class="download-box"
      @click="jumpToDownload">
      <icon-svg
        v-if="!isStarRiver"
        icon-class="ic-xiazaizhongxin"
        class="icon"></icon-svg>
      <!-- <span class="download-btn">下载中心</span> -->
      <el-button
        size="small"
        type="primary"
        class="download-box-btn primary-btn"
        :class="!isStarRiver ? 'dark-btn' : ''">
        下载中心</el-button
      >
    </div>
    <div
      class="technicalSupport"
      v-if="isStarRiver">
      <el-dropdown trigger="hover">
        <div class="user-name-box">
          <el-button
            type="primary"
            size="small"
            class="technicalSupport-btn">
            <icon-svg
              icon-class="icon-lianxizixun"
              class="icon"></icon-svg>
            技术支持
          </el-button>
        </div>
        <el-dropdown-menu
          slot="dropdown"
          class="technicalSupport-box">
          <div class="technicalSupport-box-header">
            <div class="technicalSupport-box-header-left">
              <div class="title">欢迎联系我们的技术人员</div>
              <div class="tag">
                <el-radio-group :value="tabs">
                  <el-radio-button
                    v-for="(item, index) in tagList"
                    :key="index"
                    :label="item.label"
                    >{{ item.label }}</el-radio-button
                  >
                </el-radio-group>
              </div>
            </div>
            <div class="technicalSupport-box-header-right">
              <img
                src="@/assets/img/service.png"
                alt="" />
            </div>
          </div>
          <div class="technicalSupport-box-content">
            <img
              src="@/assets/img/techQRCode.png"
              alt="" />
            <div class="phone">
              <icon-svg
                icon-class="icon-lianxifangshi"
                class="icon"
                size="13" />
              15127319880
            </div>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div
      v-if="!isPrivate && !isStarRiver"
      class="download-box developer-box">
      <el-button
        type="primary"
        size="small"
        class="download-box-btn primary-btn"
        @click="enterDeveloper">
        开发者中心
      </el-button>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

import { logoutService, refreshTokenService } from '@/service/interface'
import { getToken, exitSystem, getTokenId } from '@/utils/generalMethods'
import { getSubScibe } from '@/service/personInfo'
import { formatFileSize, Converter } from '@/utils/generalMethods.js'
import { userCenterType } from '@/views/packageCenter/index.js'
import dayjs from 'dayjs'
import EventBus from '@/utils/eventBus'

export default {
  data() {
    return {
      isStarRiver: window.isStarRiver,
      isLogoVisible: window.isLogoVisible,
      isPrivate: window.isPrivate,
      imageBaseUrl: window.imageBaseUrl,
      isCloseTab: window.isCloseTab,
      themeType: this.getThemeType(),
      popInfo: {},
      tagList: [
        {
          label: '扫码联系'
        },
        {
          label: '拨打电话'
        }
      ],
      tabs: '扫码联系'
    }
  },
  props: {
    userInfo: Object,
    enterUserCenter: Function
  },
  computed: {
    userInfoType() {
      const trialingType =
        this.popInfo?.trialing === undefined ? 0 : this.popInfo?.trialing
      const type = trialingType ? 0 : 1
      return userCenterType[type]
    },
    countIsExpired() {
      return (
        !this.popInfo?.noneSubscribe &&
        !this.popInfo?.trialing &&
        !this.popInfo?.subscribing
      )
    },
    showSubscribe() {
      return !this.$route.path.startsWith('/singleProject') && this.isStarRiver
    },
    diskUsedSpace() {
      if (this.popInfo?.diskVolumeUsed === 0) {
        return '0B'
      }
      const data = formatFileSize(this.popInfo?.diskVolumeUsed)
      return data.fileSize + data.unit
    },
    usedProgress() {
      if (
        (!this.popInfo?.diskVolumeUsed && this.popInfo?.diskVolumeUsed !== 0) ||
        (!this.popInfo?.diskVolume && this.popInfo?.diskVolume !== 0)
      ) {
        return 0
      }

      const usedSpace = new Converter(
        this.popInfo?.diskVolumeUsed > 0 ? this.popInfo?.diskVolumeUsed : 0
      )
        .from('B')
        .toGB()
      if (Number(usedSpace) >= Number(this.popInfo?.diskVolume)) {
        return 100
      }
      const size = (Number(usedSpace) / Number(this.popInfo?.diskVolume)) * 100

      const numberData = Number(size) > 100 ? 100 : Number(size)
      return Number.isInteger(numberData)
        ? numberData
        : Number(numberData.toFixed(2))
    },
    canUsedSpace() {
      if (
        (!this.popInfo?.diskVolumeUsed && this.popInfo?.diskVolumeUsed !== 0) ||
        !this.popInfo?.diskVolume
      ) {
        return '0B'
      }
      const allSize = new Converter(this.popInfo?.diskVolume).from('GB').toB()
      const usedSize = new Converter(this.popInfo?.diskVolumeUsed)
        .from('B')
        .toB()
      if (Number(usedSize) >= Number(allSize)) {
        return '0B'
      } else {
        const formatSize = formatFileSize(allSize - usedSize)
        return formatSize.fileSize + formatSize.unit
      }
    },
    endTime() {
      if (this.popInfo?.noneSubscribe) {
        return this.popInfo?.trialExpirationTime
      }
      const isTrialing = this.popInfo?.trialing
      const isSubscribe = this.popInfo?.subscribing
      const expireDate = isTrialing
        ? dayjs(this.popInfo.trialExpirationTime).format('YYYY-MM-DD HH:mm:ss')
        : isSubscribe
        ? dayjs(this.popInfo.expirationTime).format('YYYY-MM-DD HH:mm:ss')
        : dayjs(this.popInfo.trialExpirationTime).format('YYYY-MM-DD HH:mm:ss')
      const today = dayjs()
      const targetDate = dayjs(expireDate)
      const formatExpireDate =
        targetDate.diff(today, 'day') > 7
          ? dayjs(expireDate).format('YYYY-MM-DD')
          : expireDate
      return !this.popInfo.trialExpirationTime && !this.popInfo.expirationTime
        ? '--'
        : formatExpireDate
    }
  },
  methods: {
    // handleUserInfo(val) {
    //   this.popInfo = val
    // },
    renewalOrder() {
      this.$router.push('/purchasePackage')
    },
    subscribeOrder() {
      EventBus.$emit('showUserInfo', true)
    },
    // 订单信息
    enterOrderCenter() {
      this.$router.push('/orderDetail')
    },

    // 获取账户信息
    async getUserCountInfo(visible) {
      if (!this.isStarRiver || !visible) return

      const { data, errMsg, isSuccess } = await getSubScibe()
      if (errMsg) {
        return this.$message.error(errMsg)
      }
      this.popInfo = data
    },

    // 购买订单
    buyOrder() {
      this.$router.push('/purchasePackage')
    },

    // 扩容空间
    addSpace() {},

    getThemeType() {
      return this.$theme.get()?.value || 'stellar-light'
    },
    handleCommand(command) {
      this.refreshToken().then(() => {
        switch (command) {
          case '1':
            this.enterUserCenter()
            break
          case '2':
            this.exitLogin()
            break
          case '3':
            this.enterOrderCenter()
            break
        }
      })
    },
    refreshToken() {
      return new Promise(resolve => {
        let oldToken = sessionStorage.getItem('oldToken')
        if (oldToken) {
          refreshTokenService({ token: oldToken }).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                sessionStorage.setItem('token', oldToken)
                sessionStorage.removeItem('oldToken')
                sessionStorage.removeItem('isDemoProj')
              } else {
                sessionStorage.removeItem('oldToken')
                sessionStorage.removeItem('isDemoProj')
                this.$message({
                  message: '登录信息已过期，请重新登录!',
                  type: 'error',
                  duration: 3 * 1000
                })
                if (window.isCloseTab) {
                  exitSystem()
                } else {
                  if (window.isPrivate) {
                    this.$router.push('/privateLogin')
                  } else {
                    this.$router.push('/login')
                  }
                  window.location.reload()
                }
              }
            }
            resolve()
          })
        } else {
          resolve()
        }
      })
    },
    jumpToDownload() {
      this.$router.push(`/downloadCenter`)
    },
    enterDeveloper() {
      let tokenId = sessionStorage.getItem('tokenId')
      tokenId = CryptoJS.AES.encrypt(tokenId, 'developer666').toString()
      tokenId = encodeURIComponent(tokenId)

      let routerUrl = `${window.developerUrl}/#/home?tokenId=${tokenId}`
      window.open(routerUrl, '_blank')
    },
    exitLogin() {
      if (this.isCloseTab) {
        exitSystem()
      } else {
        logoutService({
          headers: {
            Authorization: getToken()
          }
        }).then(res => {
          if (res.status === 200) {
            let data = res.data
            if (data.isSuccess) {
              this.$message.success('退出登录')
              localStorage.removeItem('subInfoFlag')
              this.setCookie('', '', -1)
              sessionStorage.clear()
              sessionStorage.setItem('loginFlag', false)
              if (window.isPrivate) {
                this.$router.push(`/privateLogin`)
              } else {
                this.$router.push(`/login`)
              }
            }
          }
        })
      }
    },
    setCookie(name, psw, exdays) {
      let exdate = new Date()
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays)

      window.document.cookie = `userName==${name};path=/;expires=${exdate.toGMTString()}`
      window.document.cookie = `password==${psw};path=/;expires=${exdate.toGMTString()}`
    },
    getTokenId,
    changeTheme(themeType) {
      this.$theme.set(themeType)
    }
  },
  mounted() {
    // getToken() && this.getUserCountInfo()
    // EventBus.$on('getUserInfo', this.handleUserInfo)
  }
  // beforeDestroy() {
  //   EventBus.$off('getUserInfo', this.handleUserInfo)
  // }
}
</script>

<style lang="less" scoped>
@import url('@/assets/css/publishSearch.less');

.user-info-container {
  display: flex;
  align-items: center;
  padding-right: 12px;

  .subscribe {
    width: 250px;
    height: 32px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    &-btn {
      width: 70px;
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }

  .user-info-box {
    display: flex;
    transition: all 0.3s;
    margin: 0 16px;
    padding-left: 5px;

    .text-overflow {
      height: 100%;
    }

    &:hover {
      background-color: var(--header-btn-hover);
      border-radius: 16px;
      padding: 5px;
      border: none;
      margin-right: 11px;
    }

    &:active {
      background-color: var(--header-btn-hover);
      border-radius: 16px;
      padding: 5px;
      border: none;
      margin-right: 11px;
    }

    .user-avatar-box {
      height: 24px;
      .common-button-box {
        .el-button {
          width: 24px;
          height: 24px;
          margin-right: 0px;
          background-color: var(--base-bg-primary-color);
          border-color: var(--base-bg-primary-color);
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 11px;
        }

        .circle-avatar {
          background-color: rgba(192, 196, 204);
          color: #fff;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .avatar {
        width: 24px;
        height: 24px;
        margin: 0px auto;
        border-radius: 50%;
        line-height: 30px;
        font-size: 30px;
        text-align: center;
        background: var(--base-primary-color);
        cursor: pointer;
      }
    }

    .common-dropdown-box {
      margin-left: 10px;
      display: flex;
      align-items: center;
      justify-content: center;

      .user-name-box {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--header-text-white-color);
        cursor: pointer;

        .name {
          max-width: 95px;
          font-size: 14px;
        }

        .icon {
          margin: auto;
          font-size: 14px;
          margin-left: 4px;
        }
      }
    }
  }

  .change-theme-box {
    margin-right: 16px;
    &-switch {
      height: 24px;

      // .el-switch__core {
      //   width: 65px !important;
      // }

      :deep(.el-switch__label--left) {
        position: absolute;
        left: 20px;
        color: #fff;
        z-index: -1111;
        cursor: default;
        user-select: none;
        transition: all 0.3s;
      }

      :deep(.el-switch__label--left.is-active) {
        z-index: 1111;
        width: 14px;
        height: 14px;
        background-color: var(--aside-bg-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-moon {
          font-size: 9px;
          color: var(--base-bg-light-color43);
        }
      }

      :deep(.el-switch__label--right) {
        position: absolute;
        right: 20px;
        color: #fff;
        z-index: -1111;
        cursor: default;
        user-select: none;
        transition: all 0.3s;
      }

      :deep(.el-switch__label--right.is-active) {
        z-index: 1111;
        width: 14px;
        height: 14px;
        background-color: var(--aside-bg-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-icon-sunny {
          font-size: 9px;
          color: var(--base-bg-light-color43);
        }
      }

      :deep(.el-switch__core) {
        height: 24px;
        border-radius: 12px;
        background-color: var(--base-bg-light-color24);
        border: none;

        &::after {
          width: 14px;
          height: 14px;
          top: 5px;
          display: none;
        }
      }
    }
  }

  .download-box {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &-btn {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 16px;
      font-size: 14px;
      font-weight: 400;
    }

    .dark-btn {
      background: none;
      padding-left: 2px;
      padding-right: 4px;
      &:hover {
        color: var(--base-primary-bgColor) !important;
      }
    }

    .icon {
      margin: 0px 5px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        left: -10px;
        top: -2px;
        width: 1px;
        height: 20px;
        background-color: #707070;
      }
    }

    &:hover {
      color: var(--base-primary-bgColor);
    }
  }

  .developer-box {
    margin-left: 8px;
  }
}

.technicalSupport {
  margin-left: 16px;
  &-btn {
    height: 32px;
    background: rgba(37, 128, 255, 0.2);
    border-radius: 16px;
    padding: 6px 16px;
    border: none;
    color: #2580ff;
    font-size: 14px;
    font-weight: 400;
    transition: all 0.3s;
    :deep(span) {
      display: flex;
      align-items: center;
      .icon {
        margin-right: 8px;
      }
    }

    &:focus,
    &:hover {
      background: rgba(37, 128, 255, 0.3);
      color: #2580ff;
    }
  }
}

.common-dropdown-menu {
  .el-select-dropdown__item {
    height: 26px;
  }
  .icon {
    margin-right: 5px;
  }
}

.usertip {
  &-expirationTime {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
    &-img {
      width: 71px;
      height: 20px;
    }
    &-text {
      flex-shrink: 0;
      color: rgba(33, 36, 41, 0.6);
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;

      .expiredDate {
        margin-left: 2px;
        font-size: 11px;
        &-text {
          color: #2580ff;
          cursor: pointer;
        }
      }
    }
  }

  &-buyOrder {
    height: 44px;
    width: 100%;
    background-image: url('@/assets/img/orderBg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    &-btn {
      position: absolute;
      bottom: 0;
      right: 0;
      cursor: pointer;
      width: 74px;
      height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.15);
      border-radius: 10px 0px 4px 0px;
      background: rgba(37, 128, 255, 0.4);
      font-size: 12px;
      line-height: 22px;
      backdrop-filter: blur(9px);

      &:hover {
        background: rgba(37, 128, 255, 0.9);
      }

      @-moz-document url-prefix() {
        &,
        &:hover {
          // 同时覆盖默认和hover状态
          backdrop-filter: none !important;
          background: rgba(37, 128, 255, 0.4) !important;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }

        &:hover {
          background: rgba(37, 128, 255, 0.9) !important; // 保留hover效果
        }
      }

      &-arrow {
        font-weight: 500;
        font-size: 12px;
        margin-left: 4px;
      }
    }
  }

  &-space {
    padding: 8px;
    margin: 8px 0;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    &-userSpace {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      color: rgba(33, 36, 41, 0.4);
      &-text {
        font-weight: 400;
        font-size: 12px;
        &-label {
          color: rgba(33, 36, 41, 0.6);
        }
      }

      &-addSpace {
        width: 40px;
        height: 22px;
        background: #ff9250;
        border-radius: 4px;
        font-size: 12px;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background: rgba(255, 146, 80, 0.8);
        }

        &:focus,
        &:active {
          background: #ff9250;
        }
      }
    }
    &-userProgress {
      margin-bottom: 4px;

      .redColor {
        :deep(.el-progress-bar__inner) {
          // background: linear-gradient(to right, #ffffff, #ffb98f);
          background-color: #ffb98f;
        }
      }

      .blueColor {
        :deep(.el-progress-bar__inner) {
          background-color: #2580ff;
        }
      }

      &-text {
        color: rgba(33, 36, 41, 0.6);
        font-size: 12px;
        font-weight: 400;
        text-align: right;
      }
    }
  }

  &-dropItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 2px 0;

    &:hover {
      background: rgba(0, 0, 0, 0.03);
      border-radius: 8px;
    }

    &-icon {
      display: flex;
      align-items: center;
    }

    &-arrow {
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 2px;
      :deep(.el-icon-arrow-right) {
        margin-right: 0;
        font-size: 10px;
      }
    }
  }
  .loginOut {
    width: 100%;
    height: 22px;
    text-align: center;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 6px 6px 6px 6px;
    color: rgba(33, 36, 41, 0.4);
    font-size: 12px;
    font-weight: 500;
    line-height: 22px;

    &:hover {
      background: rgba(0, 0, 0, 0.08);
      color: rgba(33, 36, 41, 0.4);
    }
  }
}
</style>

<style lang="less">
.common-dropdown-menu-topMenu {
  width: 256px !important;
  transform: translateX(20px);

  .el-dropdown-menu__item {
    padding: 0 !important;
    color: #212429;
    &:hover {
      background: transparent !important;
      color: #212429 !important;
    }
  }

  .usertip-space-userProgress {
    .el-progress-bar__innerText {
      display: none;
    }
  }
}

.common-dropdown-menu-darkMenu {
  width: 124px !important;

  .dropdown-menu {
    font-size: 14px;
  }
  .el-dropdown-menu__item {
    height: 26px;
    font-size: 14px;
    font-weight: 400;
    &:hover {
      background-color: var(--home-menu-dropdown-hover-bgColor) !important;
      color: var(--dropdown-text-color) !important;
      border-radius: 4px;
    }

    &:active {
      background-color: var(--home-menu-dropdown-hover-bgColor) !important;
      color: var(--dropdown-text-color) !important;
      border-radius: 4px;
    }

    &:focus {
      background-color: var(--home-menu-dropdown-hover-bgColor) !important;
      color: var(--dropdown-text-color) !important;
      border-radius: 4px;
    }
  }
}

.technicalSupport-box {
  width: 232px;
  height: 280px;
  background: linear-gradient(to bottom, #e9f4ff, #ffffff);
  padding: 20px !important;
  border-radius: 8px !important;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &-left {
      font-weight: 500;
      font-size: 12px;
      color: rgba(33, 36, 41, 0.9);
      margin-right: 8px;
      .title {
        margin-bottom: 4px;
      }

      .tag {
        .el-radio-group {
          display: flex;
          align-items: center;
          border: 1px solid #2580ff;
          border-radius: 3px;
          .el-radio-button {
            width: 65px;
            height: 24px;

            &:focus {
              box-shadow: none !important;
            }

            &__inner {
              font-weight: 400;
              font-size: 12px;
              color: #2580ff;
              padding: 0;
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 0;
              background: rgba(37, 128, 255, 0.1);
              border: none;
              box-shadow: none;
            }

            &.is-active {
              background: #2580ff;
              .el-radio-button__inner {
                color: #ffffff;
              }
            }
          }
        }
      }
    }

    &-right {
      width: 50px;
      height: 58px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
    img {
      width: 140px;
      height: 140px;
      margin-bottom: 10px;
    }
    .phone {
      font-weight: 500;
      font-size: 12px;
      color: rgba(33, 36, 41, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        margin-right: 4px;
      }
    }
  }
}
</style>
